import { RoleStepKey } from '@internal/components/app/roles';

export enum RolesTab {
  YourRoles = 'your-roles',
  Explore = 'explore',
}

export const ROLE_QUERY_KEY = 'role';

export const START_QUERY_KEY = 'start';

export enum RoleStart {
  Call = 'call',
}

export enum RoleStepStatus {
  Available = 'available',
  Locked = 'locked',
  Done = 'done',
  Skipped = 'skipped',
  Scheduled = 'scheduled',
  Pending = 'pending',
  AwaitingReview = 'awaiting_review',
  Error = 'error',
}

export enum StepStatusTone {
  Accent = 'accent',
  Success = 'success',
  Warning = 'warning',
  Muted = 'muted',
  Error = 'error',
}

export interface RoleStepAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  testId?: string;
  primary?: boolean;
}

export interface RoleStep {
  key: RoleStepKey;
  title: string;
  description?: string;
  status: RoleStepStatus;
  statusLabel?: string;
  statusHint?: string;
  action?: RoleStepAction;
}
